import { useMutation } from '@tanstack/react-query';
import * as qs from 'qs';

import type { ITableSorting } from '@model/tableSorting';

import { apiClient } from '@services/apiClient';

interface IFilter {
  urgency: string;
  type: string;
  state: string;
}

interface IParams {
  filter: IFilter;
  locationId: string;
  searchValue: string;
  facilityId: number | null;
  levelName: string;
  sorting?: ITableSorting;
}

const reportActiveActionItemsListFn = ({
  filter,
  locationId,
  searchValue,
  facilityId,
  levelName,
  sorting,
}: IParams) => {
  const filters = {
    type: filter.type === 'all' ? undefined : filter.type,
    urgency: filter.urgency === 'all' ? undefined : filter.urgency,
    state: filter.state === 'all' ? undefined : filter.state,
  };

  const facility_id = facilityId === null || levelName !== 'facility' ? undefined : facilityId;
  const location_id = locationId === 'all' || levelName !== 'area' ? undefined : locationId;
  const trimmedSearchValue = searchValue.trim();
  const search = trimmedSearchValue === '' ? undefined : trimmedSearchValue;
  const direction = !sorting?.id ? undefined : sorting?.desc ? 'desc' : 'asc';
  const sort = sorting?.id ? [{ field: sorting.id, direction }] : undefined;

  const params = {
    filters,
    facility_id,
    location_id,
    search,
    sort,
  };

  return apiClient.get(`${APP_API_URL_V2}fsd/action-item/report/active-action-items-list/export`, {
    params,
    paramsSerializer: {
      serialize: (params) => qs.stringify(params),
    },
    responseType: 'arraybuffer',
    headers: {
      Accept: 'application/octet-stream',
    },
  });
};

export const useReportActiveActionItemsListMutation = () => {
  return useMutation({
    mutationFn: reportActiveActionItemsListFn,
  });
};
